const config = {
  basename: '/',
  defaultPath: '/',
  fontFamily: 'var(--font-family-primary)',
  timeInterval: 10000,
  stacBackendurl: import.meta.env.VITE_STAC_BACKEND_URL || '/api/stac/v1',
  stacCubeUrl: import.meta.env.VITE_STAC_CUBE_URL || 'https://app.aetosky.com/aetos-cube/api/stac/v1',
  mainBackendUrl: import.meta.env.VITE_MAIN_BACKEND_URL || '/api',
  regionBoundaryUrl: import.meta.env.VITE_REGION_BOUNDARY_URL || 'https://app.aetosky.com/api/services/geocode',
  tileServerUrl: import.meta.env.VITE_TILE_SERVER_URL || '',
  authUrl: import.meta.env.VITE_AUTH_URL || '',
  companionUrl: import.meta.env.VITE_COMPANION_URL || '/companion',
  geocodeUrl: import.meta.env.VITE_GEOCODE_URL || 'https://app.aetosky.com/api/services/geocode',
  domainUrl: import.meta.env.VITE_DOMAIN_URL || '',
  tilerUrl: import.meta.env.VITE_TILER_URL || '/tiler',
  homeDashboardUrl: import.meta.env.VITE_HOME_DASHBOARD_URL || 'https://vps.nbss.co.id/Dashboard'
}

export default config
